module.exports = __webpack_public_path__ + "files/SPIADI - Guide Pratique Lily.396613297c57602ea5fff378e4afb7dc.pdf";